import { _DEBUG } from './constants';

/**
 * Set a cookie
 * @param {string} cname key
 * @param {string} cvalue value
 * @param {int} [exdays] number of days the cookie lasts
 * @param {string} [path] where the cookie is valid
 */
export const setCookie = (cname, cvalue, exdays, path) => {
  if (_DEBUG) {
    console.log('setCookie()');
  }
  let expires = '';
  if (exdays) {
    let d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    expires = ';expires=' + d.toUTCString();
  }
  let pathParam = '';
  if (path) {
    pathParam = ';path=' + path;
  }
  let secureParam = '';
  if (window.location.protocol === 'https:') {
    secureParam = ';secure';
  }
  document.cookie = cname + '=' + cvalue + expires + secureParam + pathParam;
};

/**
 * Get value of the give cookie
 * @param d
 * @returns {string}
 */
export let getCookie = (d) => {
  const b = d + '=';
  const a = document.cookie.split(';');
  for (let e = 0; e < a.length; e++) {
    //const f = a[e].trim();
    const f = $.trim(a[e]);
    if (f.indexOf(b) === 0) {
      return f.substring(b.length, f.length);
    }
  }
  return '';
};
